import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEMarriagesIncomeRowActions = {
  initPeMarriagesIncomeRow: ({ commit }, index) => {
    commit('setPeMarriagesIncomeRowLock', { index, lock: true })
  },
  peMarriagesdIncomeRefreshAll: ({ state, dispatch, commit }) => {
    for (const spouse of state.partyEdit.party.spouses) {
      dispatch('peMarriagesCardRefresh', { section: spouse, index: spouse.id })
      commit('setPeMarriagesIncomeRowLock', { index: spouse.id, lock: true })
    }
  },
  peMarriagesIncomeRowUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        spouses: {
          party_id: party.id,
          monthly_income: section.monthly_income,
          income_verification: section.income_verification,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeMarriagesIncomeRowLock', { index, lock: true })
        commit('pePatchParty', {
          spouses: updatedParty.spouses || [],
        })
      }).
      catch(handleError)
  },
}

export const PEMarriagesIncomeRowMutations = {
  setPeMarriagesIncomeRowLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.MarriagesIncomeRow) {
      Vue.set(state.partyEdit.partySections, 'MarriagesIncomeRow', {})
    }
    Vue.set(state.partyEdit.partySections.MarriagesIncomeRow, index, lock)
  },
}

export const PEMarriagesIncomeRowGetters = {
  peMarriagesIncomeRowLock: state => index => state.partyEdit.partySections.MarriagesIncomeRow[index],
}
